export const TEXT_AREA_MARGIN_SPACING = 12;
